export enum EventBusActions {
  selectedBranchDetailsReceived = 1,
}
